import React, { useState, useEffect, useCallback } from 'react'
import { useParams, useHistory } from 'react-router-dom'
import { connect } from 'react-redux'
import {
  Box, Paper, Typography, Button, CircularProgress, IconButton
} from '@material-ui/core'
import { ArrowBack, Build as BuildIcon } from '@material-ui/icons'
import axios from 'axios'
import ServiceTable from './ServiceTable'
import ServiceDetailPanel from './ServiceDetailPanel'

const ServiceBuilderView = (props) => {
  const { projectId } = useParams()
  const history = useHistory()
  const { url } = props

  const [project, setProject] = useState(null)
  const [serviceSummary, setServiceSummary] = useState([])
  const [services, setServices] = useState([])
  const [selectedServiceId, setSelectedServiceId] = useState(null)
  const [loading, setLoading] = useState(true)

  const fetchData = useCallback(async () => {
    try {
      setLoading(true)
      const [projRes, summaryRes, svcRes] = await Promise.all([
        axios.get(`${url}/api/bid-estimation/projects/${projectId}`),
        axios.get(`${url}/api/bid-estimation/projects/${projectId}/service-summary`),
        axios.get(`${url}/api/bid-estimation/services`)
      ])
      setProject(projRes.data)
      setServiceSummary(summaryRes.data || [])
      setServices(svcRes.data || [])
    } catch (err) {
      console.error('ServiceBuilder fetch error:', err)
    } finally {
      setLoading(false)
    }
  }, [url, projectId])

  useEffect(() => { fetchData() }, [fetchData])

  const selectedService = serviceSummary.find(s => s.serviceId === selectedServiceId)

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight={400}>
        <CircularProgress />
      </Box>
    )
  }

  return (
    <Box p={2}>
      {/* Header */}
      <Box display="flex" alignItems="center" mb={2}>
        <IconButton size="small" onClick={() => history.push(`/bid-estimation/${projectId}`)}>
          <ArrowBack />
        </IconButton>
        <BuildIcon style={{ marginLeft: 8, marginRight: 8, color: '#2e7d32' }} />
        <Typography variant="h6">
          Service Builder — {project ? project.name : ''}
        </Typography>
      </Box>

      {/* Two-column layout */}
      <Box display="flex" gap={2}>
        <Box flex="0 0 65%" style={{ marginRight: 16 }}>
          <Paper variant="outlined">
            <ServiceTable
              serviceSummary={serviceSummary}
              services={services}
              selectedServiceId={selectedServiceId}
              onSelectService={setSelectedServiceId}
            />
          </Paper>
        </Box>
        <Box flex="0 0 33%">
          {selectedService ? (
            <ServiceDetailPanel
              service={selectedService}
              services={services}
              projectId={projectId}
              url={url}
              onUpdate={fetchData}
            />
          ) : (
            <Paper variant="outlined" style={{ padding: 24, textAlign: 'center' }}>
              <Typography color="textSecondary">
                Select a service from the table to view details and set attributes.
              </Typography>
            </Paper>
          )}
        </Box>
      </Box>
    </Box>
  )
}

const mapStateToProps = (state) => ({
  url: state.url,
  user: state.user
})

export default connect(mapStateToProps)(ServiceBuilderView)
